﻿import { store, store$ } from '@redux/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import modalService from 'layout/services/modalService';
import uiStateSlice from 'layout/redux/uiStateSlice';
import MiniCardSlider from './miniCardSlider';
import ReadMore from './readMore';

const { actions } = uiStateSlice;
const close = () => modalService.clearHtml();
const isExtendedCard = (state) => state?.uiState?.modalInformation?.name === 'extendedCard';
const modalInformation = (state) => state?.uiState?.modalInformation;

/**
 * If the modal, container, imageItemTemplate, and brokenTemplate exist, then create a new
 * SliderCarousel object with the container, imageItemTemplate, brokenTemplate, and onCreateImage as
 * parameters.
 */
const init = () => {
  const modal = document.querySelector('.flyover__card');

  modal.querySelector('#nhs_CardClose').addEventListener('click', close);

  (() => new MiniCardSlider())();

  const textElement = modal.querySelector('.about__description');
  const readMore = new ReadMore();
  readMore.addReadMoreToggle(textElement);
};

/* Dispatching an action to the store to fetch the extended card. */
const fetchExtendedCard = (extendedCardInformation) => {
  store.dispatch(
    actions.fetchModal({
      isFetchingModal: true,
      parameters: extendedCardInformation,
    })
  );
};

modalService.onHtmlReady({ name: 'extendedCard', fn: init });

store$
  .pipe(filter(modalInformation), filter(isExtendedCard), map(modalInformation), distinctUntilChanged())
  .subscribe(fetchExtendedCard);
